const constants = {
  LOCAL_STORAGE_KEYS: {
    TOKEN: 'auth_token',
    REFRESH_TOKEN: 'auth_refresh_token',
    THEME: 'sliceal-theme',
    // Where the UAE Pass link callback returns to. Persisted because linking
    // is a full-page round-trip through UAE Pass.
    UAE_PASS_LINK_RETURN_TO: 'uae_pass_link_return_to',
  },
  PORTAL_CODE: 'IN',
} as const

export default constants
